module.exports = __webpack_public_path__ + "static/img/btn4_hover.5b889bf0.png";